module.exports = __webpack_public_path__ + "img/thumbCongrtulations.fb79d6ad.svg";